import { render, staticRenderFns } from "./promote-detail.vue?vue&type=template&id=6340e6b5&"
import script from "./promote-detail.vue?vue&type=script&lang=js&"
export * from "./promote-detail.vue?vue&type=script&lang=js&"
import style0 from "./promote-detail.vue?vue&type=style&index=0&id=6340e6b5&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports